// extracted by mini-css-extract-plugin
export var labelWrapper = "_m6-0";